import { Box, Flex, MenuItem, Text, useTheme } from '@chakra-ui/react';
import React from 'react';
import { LogoWordmark } from '../../icons';

export const PoweredByRemark: React.FC<{}> = () => {
  return (
    <Box
      p="9px 16px"
      border="0.5px solid"
      borderColor="scheme.borderPrimary"
      borderRadius="8px"
      w="fit-content"
      margin="auto"
      boxShadow="0px 2px 4px rgba(0, 0, 0, 0.06)"
      cursor="pointer"
    >
      <Flex align="flex-end" as="a" href="https://www.withremark.com/" target="_blank">
        <Text variant="label-small" color="scheme.contentTertiary" whiteSpace="nowrap" lineHeight="11px">
          Powered by
        </Text>
        <LogoWordmark color="scheme.contentSecondary" h="14px" ml="6px" />
      </Flex>
    </Box>
  );
};

export const MenuItemPoweredByRemark: React.FC<{}> = () => {
  return (
    <MenuItem
      p="9px 12px"
      w="100%"
      margin="auto"
      cursor="pointer"
      onClick={() => {
        window.open('https://www.withremark.com/', '_blank');
      }}
      _hover={{
        background: 'scheme.backgroundPrimary'
      }}
    >
      <Flex align="flex-end" as="a" href="https://www.withremark.com/" target="_blank" tabIndex={0}>
        <Text variant="label-small" color="scheme.contentTertiary" whiteSpace="nowrap" lineHeight="11px">
          Powered by
        </Text>
        <LogoWordmark color="scheme.contentSecondary" h="14px" ml="6px" />
      </Flex>
    </MenuItem>
  );
};

export const InChatPoweredByRemark: React.FC<{}> = () => {
  return (
    <Box w="100%" margin="auto" background="transparent" pt="8px">
      <Flex align="baseline" justify="center" opacity={0.7}>
        <Text
          variant="label-small"
          color="scheme.contentTertiary"
          whiteSpace="nowrap"
          lineHeight="10px"
          fontSize="11px"
          aria-hidden="true"
        >
          We run with
        </Text>
        <LogoWordmark color="scheme.contentTertiary" h="9.5px" ml="5px" aria-role="presentation" />
      </Flex>
    </Box>
  );
};
